<template>
  <div class="columns">
    <div class="column is-three-quarter">
      <b-field>
        <p class="control">
          <b-tooltip position="is-bottom" :label="$t('Smaller')">
            <b-button
              @click="decreaseZoom"
              size="is-medium"
              icon-left="minus-square"
            />
          </b-tooltip>
        </p>
        <p class="control">
          <b-tooltip position="is-bottom" :label="$t('Larger')">
            <b-button
              @click="increaseZoom"
              size="is-medium"
              icon-left="plus-square"
            />
          </b-tooltip>
        </p>
        <p class="control">
          <b-dropdown :value="displayMode" @change="setDisplayMode">
            <template #trigger>
              <b-tooltip position="is-bottom" :label="$t('Set view')">
                <b-button size="is-medium" icon-left="eye" />
              </b-tooltip>
            </template>
            <b-dropdown-item value="overlay">
              <div class="media">
                <b-icon icon="image" class="media-left" />
                <div class="media-content">{{ $t("Overlay") }}</div>
              </div>
            </b-dropdown-item>
            <b-dropdown-item value="aside">
              <div class="media">
                <b-icon icon="columns" class="media-left" />
                <div class="media-content">{{ $t("Aside") }}</div>
              </div>
            </b-dropdown-item>
          </b-dropdown>
        </p>
        <p class="control">
          <b-tooltip position="is-bottom" :label="$t('Download')">
            <b-button
              @click="showModal"
              size="is-medium"
              icon-left="download"
            />
          </b-tooltip>
        </p>
        <p class="control" v-if="!showTextVisibilityToggle">
          <b-dropdown :value="tagMode" @change="setTagMode">
            <template #trigger>
              <b-tooltip position="is-bottom" :label="$t('Show tags')">
                <b-button size="is-medium" icon-left="tags" />
              </b-tooltip>
            </template>
            <b-dropdown-item value="hidetags">
              <div class="media">
                <b-icon icon="eye-slash" class="media-left" />
                <div class="media-content">{{ $t("Hide") }}</div>
              </div>
            </b-dropdown-item>
            <b-dropdown-item value="showtags">
              <div class="media">
                <b-icon icon="eye" class="media-left" />
                <div class="media-content">{{ $t("Show tags") }}</div>
              </div>
            </b-dropdown-item>
            <b-dropdown-item value="showtei">
              <div class="media">
                <b-icon icon="code" class="media-left" />
                <div class="media-content">{{ $t("XML format") }}</div>
              </div>
            </b-dropdown-item>

            <b-dropdown-item value="showList">
              <div class="media">
                <b-icon icon="columns" class="media-left" />
                <div class="media-content">{{ $t("Show List") }}</div>
              </div>
            </b-dropdown-item>
          </b-dropdown>
        </p>
        <p v-if="showTextVisibilityToggle" class="control">
          <b-tooltip
            :always="!hasToggledTextVisibility"
            position="is-bottom"
            :label="$t('Show text')"
          >
            <b-button
              @click="toggleTextVisibility"
              :class="{ 'is-link': isTextVisible }"
              size="is-medium"
              icon-left="file-alt"
            />
          </b-tooltip>
        </p>
      </b-field>
    </div>
    <div class="column is-one-quarter">
      <b-field>
        <p class="control">
          <b-tooltip position="is-bottom" :label="$t('Buy')">
            <b-button
              @click="openBuyForm"
              size="is-medium"
              icon-left="shopping-cart"
            />
          </b-tooltip>
        </p>
      </b-field>
    </div>
  </div>
</template>

<script>
import EventBus from "@/utils/event-bus.js";

import { createNamespacedHelpers } from "vuex";

const { mapState, mapActions, mapGetters } = createNamespacedHelpers("browser");

import BrowseDownload from "@/components/BrowseDownloadModal.vue";
import BuyFormModalVue from "./BuyFormModal.vue";

export default {
  props: {
    displayMode: {
      type: String,
      required: true,
    },
    tagMode: {
      type: String,
      required: true,
    },
    showTextVisibilityToggle: {
      type: Boolean,
      default: true,
    },
  },
  computed: {
    ...mapGetters([
      "isTextVisible",
      "hasToggledTextVisibility",
      "image",
      "pageURL",
    ]),
  },
  methods: {
    ...mapActions(["toggleTextVisibility"]),
    setDisplayMode(value) {
      EventBus.$emit("SET_DISPLAY_MODE", value);
      this.$emit("input", { type: "display", value });
    },
    setTagMode(value) {
      EventBus.$emit("SET_TAG_MODE", value);
      this.$emit("input", { type: "tag", value });
    },
    increaseZoom() {
      EventBus.$emit("INCREASE_ZOOM");
      this.$emit("input", { type: "zoom", delta: 1 });
    },
    decreaseZoom() {
      EventBus.$emit("DECREASE_ZOOM");
      this.$emit("input", { type: "zoom", delta: -1 });
    },
    showModal() {
      var imageKey = this.image
        .replace("https://files.transkribus.eu/iiif/2/", "")
        .replace("/info.json", "");
      var xmlkey = this.pageURL.replace(
        "https://files.transkribus.eu/Get?id=",
        ""
      );
      this.$buefy.modal.open({
        parent: this,
        component: BrowseDownload,
        canCancel: true,
        props: {
          imageKey: imageKey,
          contentKey: xmlkey,
        },
      });
    },
    openBuyForm() {
       var modal = this.$buefy.modal.open({
        parent: this,
        component: BuyFormModalVue,
        canCancel: true,
        events: {
          closeModal: (value) => {
            modal.close();
          },
        },
      });
    },
  },
};
</script>
